// extracted by mini-css-extract-plugin
export default {"box":"components_box__lxaH8","container":"components_container__4DYfz","center":"components_center__IPfp5","left":"components_left__KtYo+","right":"components_right__lugdV"};